import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'component-library';
import { useTranslation } from 'react-i18next';

import { ChartDataItem } from '@/components/Charts/HabitatConnectivity';
import { getDisplayNumber } from '@/hooks/useDisplayNumber';

type PlotsDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
} & Pick<ChartDataItem, 'label' | 'plots'>;

export const PlotsDialog = ({ open, onOpenChange, label, plots }: PlotsDialogProps) => {
  const { t } = useTranslation();
  const unit = t('global.ui.unit.%');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-4xl'>
        <DialogHeader>
          <DialogTitle className='text-left text-2xl'>
            {`${label} ${t('shared.ncaDetail.details.habitatConnectivity.labels.coreHabitat')}`}
          </DialogTitle>
        </DialogHeader>
        <DialogBody className='max-h-[60vh] rounded-lg border border-divider'>
          <Table className='w-full h-full overflow-hidden'>
            <TableHeader>
              <TableRow>
                <TableHead>{t('shared.ncaDetail.details.habitatConnectivity.labels.plotDialogNameColumn')}</TableHead>
                <TableHead>
                  {`${t('shared.ncaDetail.details.habitatConnectivity.labels.coreHabitat')} ${unit}`}
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody className='overflow-y-auto'>
              {plots.map((plot) => (
                <TableRow key={plot.id}>
                  <TableCell>{plot.name}</TableCell>
                  <TableCell>{`${getDisplayNumber(plot.value * 100)} ${unit}`}</TableCell>
                </TableRow>
              ))}
              {plots.length === 0 && (
                <TableRow>
                  <TableCell colSpan={2} className='text-center text-text-secondary py-4'>
                    {t('shared.ncaDetail.details.habitatConnectivity.labels.noPlots')}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
